export const LINKS = [
  'faq',
  'mails',
  'uk',
  'activities',
  'messages',
  'files',
  'groups',
  'marketplace/providers',
  'marketplace/all-providers',
  '/mail/create',
  'profile',
  'providers',
  'marketplace/offers',
  'marketplace/orders',
  'personal',
  'corporate',
  '/settings/users',
  'residents',
  'contractors',
  'marketplace',
]
